import React from "react";

import StampIconUploader from "./StampIconUploader";
import {
  campaignCreationActivePeriodSectionConfig,
  campaignCreationCampaignListingSectionConfig,
  campaignCreationDetailSectionConfig,
  campaignCreationGeneralSectionConfig,
  campaignCreationInstructionSectionConfig,
  campaignCreationKeyVisualSectionConfig,
  campaignCreationRecurringCampaignSections,
  campaignCreationTargetCustomerSectionConfig
} from "containers/engagement/campaignStreamline/CreateCampaignContentPageConfig";
import VisibleMallSection from "components/campaign/campaignCreation/VisibleMallSection";
import { ProcessEnvConfig } from "config/ProcessEnvConfig";
import VisiblePeriodSection from "components/campaign/campaignCreation/VisiblePeriodSection";
import RewardSection from "./RewardSection";
import StampCampaignTasks from "./StampCampaignTasks";
import StampCampaignPreviewContentCard from "./StampCampaignPreviewContentCard";
import StampCampaignPreviewRewardCard from "./StampCampaignPreviewRewardCard";
import StampCampaignPreviewPropertiesCard from "./StampCampaignPreviewPropertiesCard";
import ReactHookFormTextInput from "components/reactHookFormComponents/ReactHookFormTextInput";
import { tierTypeConfig } from "config/TierTypeConfig";
import {
  STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY,
  STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY,
  STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY,
  STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY
} from "config/PageAnchorConfig/StampCampaignAnchorConfig";


export const CREATION_STEP_ONE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    const isExclusive = watch('isExclusive');
    const excludeBlacklistSegment = watch('excludeBlacklistSegment');
    const haveHomepageBanner = watch('haveHomepageBanner');
    const showInOfferTab = watch('showInOfferTab');
    const isBirthdayRecurringCampaign = watch('isBirthdayRecurringCampaign');
    let displayLanguageSectionComponents = [
      ...campaignCreationGeneralSectionConfig.keys,
      ...campaignCreationGeneralSectionConfig.getDisplayKeys(isExclusive, excludeBlacklistSegment),
      ...campaignCreationKeyVisualSectionConfig.getDisplayKeys(isExclusive),
      STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
      ...campaignCreationInstructionSectionConfig.keys,
      ...campaignCreationDetailSectionConfig.keys,
      ...campaignCreationCampaignListingSectionConfig.getDisplayKeys(haveHomepageBanner, showInOfferTab),
      ...(ProcessEnvConfig.haveShopMall ? [STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionContent.visible_mall_key] : []),
      ...campaignCreationActivePeriodSectionConfig.keys,
      STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionContent.visible_period_section_key,
      STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaign.sectionContent.recurring_birthday_selector_key,
      ...(isBirthdayRecurringCampaign
        ? [
          STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignActivePeriod.sectionContent.recurring_birthday_active_period_selector_key,
          STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringCampaignVisiblePeriod.sectionContent.recurring_birthday_visible_period_selector_key,
          ...(tierTypeConfig.messages
              ? [STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.recurringMessage.sectionContent.recurring_message_selector_key,]
              : []
            ),
        ]
        : []
      ),
    ]

    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents
    }
  },
  normalSections: [],
  languageSections: [
    campaignCreationGeneralSectionConfig.section,
    {
      ...campaignCreationTargetCustomerSectionConfig.section,
      description: null,
      descriptionClass: null,
    },
    {
      ...campaignCreationKeyVisualSectionConfig.section,
      sectionContent: [
        ...campaignCreationKeyVisualSectionConfig.section.sectionContent,
        {
          key: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.keyVisual.sectionContent.stamp_campaign_upload_stamp_icon_key,
          component: StampIconUploader,
        },
      ]
    },
    campaignCreationInstructionSectionConfig.section,
    campaignCreationDetailSectionConfig.section,
    campaignCreationCampaignListingSectionConfig.section,
    {
      sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionKey,
      hideInOtherLanguages: true,
      sectionContent: [
        {
          key: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.mall.sectionContent.visible_mall_key,
          component: VisibleMallSection,
        },
      ],
    },
    campaignCreationActivePeriodSectionConfig.section,
    {
      sectionKey: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionKey,
      hideInOtherLanguages: true,
      sectionContent: [
        {
          key: STAMP_CAMPAIGN_CONTENT_PAGE_ANCHOR_KEY.visiblePeriod.sectionContent.visible_period_section_key,
          component: VisiblePeriodSection,
        },
      ],
    },
    ...campaignCreationRecurringCampaignSections,
  ]
}

export const CREATION_STEP_TWO_CONFIG = {
  getDisplayComponentKeys: (...props) => {
    return {
      displayNormalSectionComponents: [
        STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionContent.stamp_tasks_key,
      ],
      displayLanguageSectionComponents: [],
    }
  },
  languageSections: [],
  normalSections: [
    {
      sectionKey: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionKey,
      sectionContent: [
        {
          key: STAMP_CAMPAIGN_RULE_PAGE_ANCHOR_KEY.tasks.sectionContent.stamp_tasks_key,
          component: StampCampaignTasks,
        }
      ]
    }
  ]
}
export const CREATION_STEP_THREE_CONFIG = {
  getDisplayComponentKeys: ({ formContext: { watch } }) => {
    return {
      displayNormalSectionComponents: [
        STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionContent.reward_section_key,
        STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionContent.execution_priority_input_key
      ],
      displayLanguageSectionComponents: [],
    }
  },
  languageSections: [],
  normalSections: [
    {
      sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionKey,
      sectionContent: [
        {
          key: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.rewards.sectionContent.reward_section_key,
          component: RewardSection,
        }
      ]
    },
    {
      sectionKey: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionKey,
      sectionTitle: "EXECUTION PRIORITY FOR GLOBAL LIMIT",
      sectionContent: [
        {
          key: STAMP_CAMPAIGN_REWARDS_PAGE_ANCHOR_KEY.executionPriority.sectionContent.execution_priority_input_key,
          component: ReactHookFormTextInput,
          componentProps: {
            customClass: "width-160px",
            type: "number",
            valueFieldName: `executionPriority`,
            title: 'Execution priority',
            tips: "Set the priority for executing earning rules linked to stamp campaigns. If a single earning rule is connected to multiple stamp campaigns and when the earning rule is triggered, the customer has reached the global reward limit, this execution priority will determine which stamp campaign should issue the stamp reward.",
            shortDescription: "Minimum value is 1. The smaller value, the higher priority."
          }
        }
      ]
    },
  ],
}

export const CREATE_STAMP_CAMPAIGN_PREVIEW_PAGE_CONFIG = {
  extraValidate: ({ getValues, setError, clearErrors }) => true,
  getDisplayComponentKeys: ({ formContext: { watch, getValues } }) => {
    return {
      displayNormalSectionComponents: [],
      displayLanguageSectionComponents: [
        "content_preview_card_key",
        "properties_preview_card_key",
        "reward_preview_card_key",
      ]
    };
  },
  normalSections: [],
  languageSections: [
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.campaignContent.sectionKey,
      sectionContent: [
        {
          key: "content_preview_card_key",
          complexComponent: ({ formContext: { getValues }, language }) => (
            <StampCampaignPreviewContentCard
              language={language}
              campaignData={getValues()}
            />
          )
        },
      ],
    },
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.properties.sectionKey,
      sectionTitle: "ruleAndProperties",
      sectionContent: [
        {
          key: "properties_preview_card_key",
          complexComponent: ({ formContext: { getValues, watch }, language }) => (
            <StampCampaignPreviewPropertiesCard
              campaignData={getValues()}
            />
          ),
        },
      ],
    },
    {
      sectionKey: STAMP_CAMPAIGN_PREVIEW_PAGE_ANCHOR_KEY.rewards.sectionKey,
      sectionTitle: "rewards",
      sectionContent: [
        {
          key: "reward_preview_card_key",
          complexComponent: ({ formContext: { getValues }, language }) => (
            <StampCampaignPreviewRewardCard
              language={language}
              campaignData={getValues()}
            />
          )
        },
      ],
    },
  ],
};
